import * as types from "./mutationTypes";

export default {
  [types.SET_DOMAINS](state, domains) {
    state.domains = domains;
  },
  [types.CLEAR_DOMAINS](state) {
    state.domains = null;
  },
  [types.REMOVE_DOMAIN](state, uuid) {
    state.domains = state.domains.filter((domain) => domain.uuid !== uuid);
  },
  [types.SET_DOMAIN](state, domain) {
    state.domain = domain;
  },
  [types.CLEAR_DOMAIN](state) {
    state.domain = null;
  },
  [types.SET_FIELD_DOMAIN](state, domain) {
    state.domain.domain = domain;
  },
  [types.SET_FIELD_SUBDOMAIN](state, subdomain) {
    state.domain.subdomain = subdomain;
  },
  [types.SET_FIELD_EMAILS](state, emails) {
    state.domain.email_list = emails;
  },
  [types.SET_EMAILS](state, emails) {
    state.emails = emails;
  },
  [types.CLEAR_EMAILS](state) {
    state.emails = null;
  }
};
